import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { useAriaLive } from '@ally/use-aria-live';
import { a11y } from './strings';
const widthStyles = {
    s: '30%',
    m: '50%',
    l: '75%',
    xl: '100%',
};
const heightStyles = {
    s: '1rem',
    m: '2rem',
    l: '3rem',
    xl: '4rem',
};
const pulse = keyframes `
  0% {
    background: rgba(128, 128, 128, 0.1);
  }
  100% {
    background: rgba(128, 128, 128, 0.2);
  }
`;
const StyledRow = styled.div `
  && {
    animation: ${pulse} 1s ease-in-out alternate infinite both;
    background: rgba(128, 128, 128, 0.1);

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    ${({ height, width }) => `
        width: ${widthStyles[width]};
        height: ${heightStyles[height]};
      `}
  }
`;
/**
 * Please do not import this component directly, as the name would be confusing if used without a wrapper
 * See the MDX file for proper usage
 * We are exporting this component here so the interface can be read in the MDX file
 */
export const Container = ({ children, isLoading = true, ariaLive = a11y.ariaLive, ariaLabel = a11y.ariaLabel, }) => {
    const { announcePolite } = useAriaLive();
    useEffect(() => {
        if (isLoading) {
            announcePolite(ariaLive);
        }
    }, [isLoading, announcePolite]);
    return (React.createElement(React.Fragment, null, isLoading && (React.createElement("section", { "data-testid": "loading-skeleton", "aria-label": ariaLabel }, children))));
};
/**
 * Please do not import this component directly, as the name would be confusing if used without a wrapper
 * See the MDX file for proper usage
 * We are exporting this component here so the interface can be read in the MDX file
 */
export const Row = ({ height = 's', width = 'xl', }) => {
    return React.createElement(StyledRow, { height: height, width: width });
};
export default { Container, Row };
//# sourceMappingURL=SkeletonLoader.js.map